import React from 'react';
import { useListDetailViewContext } from 'Components/ComponentLibrary/Organisms/ListDetailView/Context';
import Container from './Container';

const DetailView = (props) => {
  const { selectedResourceRelationshipLink } = useListDetailViewContext();

  if (selectedResourceRelationshipLink === undefined || selectedResourceRelationshipLink === null) {
    return null;
  }

  return (
    <Container {...props} relationshipLink={selectedResourceRelationshipLink} />
  );
};

DetailView.propTypes = {
};

export default DetailView;
